module.exports = __webpack_public_path__ + "img/products_big_can_original2.f7aab1d3.png";